import axios from "axios";
import packageJson from "package.json";

export const apiOld = axios.create({
  headers: {
    "x-data-version": packageJson.version,
  },
  paramsSerializer: {
    indexes: null,
  },
});
